import React from 'react';
import { X } from 'lucide-react';

export type AppliedFilterChip = {
  key: string;
  label: string;
  onRemove?: () => void;
};

export default function AppliedFilters({
  items,
  onClear,
}: {
  items: AppliedFilterChip[];
  onClear?: () => void;
}) {
  if (!items.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">Applied filters</span>
      {items.map((item) => (
        <span
          key={item.key}
          className="inline-flex items-center gap-1 rounded-full bg-primary-50 text-primary-800 ring-1 ring-primary-200 px-2.5 py-1 text-xs font-medium"
        >
          {item.label}
          {item.onRemove ? (
            <button
              type="button"
              onClick={item.onRemove}
              className="rounded-full p-0.5 hover:bg-primary-100"
              aria-label={`Remove ${item.label}`}
            >
              <X className="h-3 w-3" />
            </button>
          ) : null}
        </span>
      ))}
      {onClear ? (
        <button
          type="button"
          className="text-xs font-semibold text-primary-700 hover:underline"
          onClick={onClear}
        >
          Clear filters
        </button>
      ) : null}
    </div>
  );
}
